import { render, staticRenderFns } from "./AsignarJugadores.vue?vue&type=template&id=2d8ab049"
import script from "./AsignarJugadores.vue?vue&type=script&lang=ts"
export * from "./AsignarJugadores.vue?vue&type=script&lang=ts"
import style0 from "./AsignarJugadores.vue?vue&type=style&index=0&id=2d8ab049&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports